import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object } from "yup";

export type RentalIncomeFormType = {
  readonly amountValue: number;
};

export const getRentalIncomeFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<RentalIncomeFormType> = (t) => {
  return object({
    amountValue: number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .min(1, t(Resources.Validation.Number.MoreThen, { count: 0 }))
      .required(t(Resources.Validation.Required)),
  }).defined();
};
